import { inject, Injectable, signal } from '@angular/core';

import { FeatureFlags } from '@data/constants';
import { FeatureFlagsRepository } from '@data/repositories';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsProvider {
  private readonly featureRepository = inject(FeatureFlagsRepository);
  private readonly _flags = signal<Map<string, boolean>>(new Map());

  async loadFeatureFlags() {
    const result = await this.featureRepository.getFeatureFlags();

    if (result.isOk === true) {
      const data = result.data;

      this._flags.set(new Map(Object.entries(data)));
    }
  }

  getFlag(key: FeatureFlags) {
    if (!this._flags().has(key)) {
      return false;
    }

    return this._flags().get(key);
  }
}
